import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "sonner";
import CookieBanner from "@/components/CookieBanner";
import { BackToTop, ScrollProgress } from "@/components/ScrollUtils";
import { fetchSiteSettings } from "@/lib/api";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  useEffect(() => {
    fetchSiteSettings().then(setSettings).catch(() => {});
  }, []);
  return (
    <div className="App flex min-h-screen flex-col bg-white">
      <ScrollProgress />
      <Header settings={settings} />
      <main className="flex-1">{children}</main>
      <Footer settings={settings} />
      <BackToTop />
      <CookieBanner settings={settings} />
      <div data-testid="admin-toast">
        <Toaster position="top-right" richColors closeButton />
      </div>
    </div>
  );
}
